import Home from "./components/Home";
import NavBar from "./components/NavBar";
import Socialinks from "./components/Socialinks";
import About from "./components/About";
import Portfolio from "./components/Portfolio";
import Experiance from "./components/Experiance";
import Contact from "./components/Contact";
function App() {
  return (
    <div>
   <NavBar />
   <Home />
   <Socialinks />
   <About />
   <Portfolio />
   <Experiance />
   <Contact />
   </div>
  );
}

export default App;
